export default class File {

  constructor (el) {
    this.el = el
    this.input = this.el.querySelector('input')
    this.name = this.el.querySelector('.js-file-name')
    this.size = this.el.querySelector('.js-file-size')
    this.clear = this.el.querySelector('.js-clear')

    this.onChangeHandler = (e) => this.onChange(e)
    this.onClearHandler = (e) => this.onClear(e)

    this.defaultName = this.name ? this.name.textContent.trim() : ''
    this.defaultSize = this.size ? this.size.textContent.trim() : ''

    this.initDefaults()
  }

  initDefaults () {
    this.initEvents()
  }

  initEvents () {
    this.input.addEventListener('change', this.onChangeHandler)
    if (this.clear) {
      this.clear.addEventListener('click', this.onClearHandler)
    }
  }

  removeEvents () {
    this.input.removeEventListener('change', this.onChangeHandler)
    if (this.clear) {
      this.clear.removeEventListener('click', this.onClearHandler)
    }
  }

  onChange (e) {
    const file = e.target.files && e.target.files[0]

    if (!file) {
      this.reset()
      return
    }

    if (this.name) {
      this.name.textContent = file.name
    }

    if (this.size) {
      this.size.textContent = this.humanFileSize(file.size, true)
    }

    this.el.classList.add('active')
  }

  onClear (e) {
    e.preventDefault()
    this.reset()
  }

  reset () {
    this.input.value = ''

    if (this.name) {
      this.name.textContent = this.defaultName
    }

    if (this.size) {
      this.size.textContent = this.defaultSize
    }

    this.el.classList.remove('active')
  }

  humanFileSize (bytes, si=false, dp=1) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
      return `(${bytes} B)`;
    }
  
    const units = si 
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10**dp;
  
    do {
      bytes /= thresh;
      ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
  
  
    return `(${bytes.toFixed(dp)} ${units[u]})`;
  }

  destroy () {
    this.removeEvents()
  }

}
